const introspection = require('graphql-introspections/queue.json')

const utils = require('sci/utils')

const {
    InMemoryCache,
    gql,
    ApolloClient,
} = require('@apollo/client/core')

const {
    WebSocketLink
} = require('@apollo/link-ws')

const {
    SubscriptionClient
} = require('subscriptions-transport-ws')

const queueUrl = utils.queueUrl('v2/graphql')
    .replace(/http(s)?:\/\/(.*)/g, 'ws$1://$2')

let state = null

module.exports = () => {
    if (state) {
        return state.client
    } else {
        const wsClient = new SubscriptionClient(queueUrl, {
            reconnect: true,
            connectionParams: {
                environment: {
                    authorization: `Bearer ${window.__sessionToken}`
                }
            },
            lazy: true,
            inactivityTimeout: 10000
        });

        const wsLink = new WebSocketLink(wsClient);

        const client = new ApolloClient({
            link: wsLink,
            cache: new InMemoryCache({
                possibleTypes: introspection.possibleTypes
            }),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                mutate: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            }
        })

        state = { client, wsLink, wsClient }

        return client
    }
}


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/queue-client-ws.js